export default Object.freeze({
  DESC: 'DESC',
  ASC: 'ASC',
});
